import Logo from "../../assets/images/logo-white.png"

const SidebarLogo = () => {
    return (
        <div className="px-4 mb-3 mx-auto">
            <img className="h-16 w-auto"
                src={Logo}
                alt="logo" />
        </div>
    )
}

export default SidebarLogo;